import { useLogo } from 'core/common/hooks';
import { Image } from 'core/common/ui/ui-kit';
import { LogoBlockStyled } from './styled';

export const Logo = () => {
  const { logoSrc } = useLogo();

  return (
    <LogoBlockStyled>
      <Image src={logoSrc} width={120} height={24} alt="logo" />
    </LogoBlockStyled>
  );
};
